"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTokenRefreshLink = void 0;
const apollo_link_token_refresh_1 = require("apollo-link-token-refresh");
function createTokenRefreshLink(authClient) {
    return new apollo_link_token_refresh_1.TokenRefreshLink({
        accessTokenField: 'idToken',
        isTokenValidOrUndefined: () => {
            return authClient.isCredentialsValidOrUndefined();
        },
        fetchAccessToken: () => __awaiter(this, void 0, void 0, function* () {
            yield authClient.refresh();
            const myBlob = new Blob([JSON.stringify(authClient.credentials, null, 2)], { type: 'application/json' });
            const init = { status: 200, statusText: 'ok' };
            return new Response(myBlob, init);
        }),
        handleFetch: () => { },
        handleError: (err) => __awaiter(this, void 0, void 0, function* () {
            throw new Error('RefreshTokenLink error: ' + err);
        })
    });
}
exports.createTokenRefreshLink = createTokenRefreshLink;
